export const lookbookMixin = {
    computed: {
        mixinDotStyle() {
            return {
                top: `calc(${this.dot.y}% - 28px)`,
                left: `calc(${this.dot.x}% - 28px)`,
            };
        },
    },
    methods: {
        mixinCheckElement(name) {
            return !this.visibleElements.includes(name);
        },
    },
};
